import { StatType } from "../types/stats";

/**
 * Formata valores monetários com o valor completo (sem abreviação K/M/B, com centavos)
 * @param value - Valor em decimal
 * @returns Valor formatado
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * Formata porcentagem
 * @param value - Valor em decimal (ex: 25.5 para 25.5%)
 * @param decimals - Número de casas decimais
 * @returns Valor formatado
 */
export const formatPercentage = (value: number, decimals: number = 1): string => {
  return `${value.toFixed(decimals)}%`;
};

/**
 * Formata contadores/números inteiros com o valor completo (sem abreviação K/M/B)
 * @param value - Valor numérico
 * @returns Valor formatado
 */
export const formatCount = (value: number): string => {
  return new Intl.NumberFormat('pt-BR').format(value);
};

/**
 * Formata valores baseado no tipo da estatística, sempre com o valor completo
 * @param stat - Objeto StatType
 * @returns Valor formatado
 */
export const formatStatValue = (stat: StatType): string => {
  const numericValue = stat.numericValue ?? (typeof stat.value === 'number' ? stat.value : 0);

  switch (stat.valueType) {
    case 'currency':
      return formatCurrency(numericValue);

    case 'percentage':
      return formatPercentage(numericValue);

    case 'count':
      return formatCount(numericValue);

    default:
      // Fallback para compatibilidade
      return typeof stat.value === 'string' ? stat.value : formatCount(numericValue);
  }
};
